import { createFileRoute } from '@tanstack/react-router';
import { isPermissionFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/regra-fiscal')({
    beforeLoad: () =>
        validateRoute({
            fintech: false,
            validatePermission: ({ upp_fiscal_regras }) => isPermissionFull(upp_fiscal_regras),
        }),
});
